<div class="modal-header">
    <h4 class="modal-title">Update Containers</h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Close button"
        (click)="activeModal.dismiss(false)"
    ></button>
</div>

<form [formGroup]="containerUpdateForm">
    <div class="modal-body">
        @if(isLoadingContainerGroups){
        <div class="alert alert-info mb-0">
            <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
            Loading containers...
        </div>
        }@else if(loadContainerGroupsError.length > 0){
        <div class="alert alert-danger mb-0">
            {{ loadContainerGroupsError }}
        </div>
        }@else if(containerGroups.length === 0){
        <div class="alert alert-info mb-0">
            No containers selected.
        </div>
        }@else if(hasTooManyContainerUpdates){
        <div class="alert alert-warning mb-0">
            Only {{ maxContainerUpdateItems }} jobs can be updated at a time.
        </div>
        }@else if(hasNonEditableContainerUpdates){
        <div class="alert alert-warning mb-0">
            Completed, billed or cancelled jobs cannot be updated.
        </div>
        }@else{
        <div class="table-responsive">
            <table class="table table-striped align-middle container-update-table">
                <thead>
                    <tr>
                        <th class="job-number-column">Job Number</th>
                        <th>Job Type</th>
                        <th>Container Number</th>
                        <th>
                            <div class="column-header">
                                <span>Order Number</span>
                                @if(containerGroups.length > 1){
                                <button type="button" class="btn btn-link apply-to-all-link" (click)="applyToAll('orderNumber')">Apply to all</button>
                                }
                            </div>
                        </th>
                        <th>
                            <div class="column-header">
                                <span>Customer Reference</span>
                                @if(containerGroups.length > 1){
                                <button type="button" class="btn btn-link apply-to-all-link" (click)="applyToAll('customerReference')">Apply to all</button>
                                }
                            </div>
                        </th>
                        <th>
                            <div class="column-header">
                                <span>Door Direction</span>
                                @if(containerGroups.length > 1){
                                <button type="button" class="btn btn-link apply-to-all-link" (click)="applyToAll('doorDirection')">Apply to all</button>
                                }
                            </div>
                        </th>
                        <th class="dangerous-goods-column">
                            <div class="column-header">
                                <span>Dangerous Goods</span>
                                @if(containerGroups.length > 1){
                                <button type="button" class="btn btn-link apply-to-all-link" (click)="applyToAll('dangerousGoods')">Apply to all</button>
                                }
                            </div>
                        </th>
                        <th>
                            <div class="column-header">
                                <span>Seal Number</span>
                                @if(containerGroups.length > 1){
                                <button type="button" class="btn btn-link apply-to-all-link" (click)="applyToAll('sealNumber')">Apply to all</button>
                                }
                            </div>
                        </th>
                        <th>
                            <div class="column-header">
                                <span>Full Grid #</span>
                                @if(containerGroups.length > 1){
                                <button type="button" class="btn btn-link apply-to-all-link" (click)="applyToAll('gridNumber')">Apply to all</button>
                                }
                            </div>
                        </th>
                        <th class="weight-column">
                            <div class="column-header">
                                <span>Weight</span>
                                @if(containerGroups.length > 1){
                                <button type="button" class="btn btn-link apply-to-all-link" (click)="applyToAll('weight')">Apply to all</button>
                                }
                            </div>
                        </th>
                        <th class="dehire-point-column">
                            <div class="column-header">
                                <span>Empty Park</span>
                                @if(containerGroups.length > 1){
                                <button type="button" class="btn btn-link apply-to-all-link" (click)="applyToAll('emptyDehirePoint')">Apply to all</button>
                                }
                            </div>
                        </th>
                        <th class="action-column">Action</th>
                    </tr>
                </thead>
                <tbody formArrayName="containerGroups">
                    @for(containerGroup of containerGroups.controls; track containerGroup){
                    @let containerGroupIndex = $index;
                    <tr [formGroupName]="containerGroupIndex">
                        <td>
                            {{ containerGroup.get('containerJobNumber')?.value }}
                        </td>
                        <td> 
                            {{ containerGroup.get('jobType')?.value }}
                        </td>
                        <td>
                            {{ containerGroup.get('containerNumber')?.value }}
                        </td>
                        <td>
                            <input type="text" class="form-control form-control-sm" formControlName="orderNumber">
                        </td>
                        <td>
                            <input type="text" class="form-control form-control-sm" formControlName="customerReference">
                        </td>
                        <td>
                            <ng-select
                                formControlName="doorDirection"
                                [items]="availableDoorDirections"
                                [appendTo]="'body'"
                                dropdownPosition="bottom"
                                placeholder="Select door direction"
                            ></ng-select>
                        </td>
                        <td class="dangerous-goods-column">
                            <ng-select
                                formControlName="dangerousGoods"
                                [items]="availableHazardCodes"
                                bindLabel="name"
                                bindValue="name"
                                [multiple]="true"
                                [appendTo]="'body'"
                                dropdownPosition="bottom"
                                placeholder="Select dangerous goods"
                            ></ng-select>
                        </td>
                        <td>
                            <input type="text" class="form-control form-control-sm" formControlName="sealNumber">
                        </td>
                        <td>
                            <input type="text" class="form-control form-control-sm" formControlName="gridNumber" maxlength="12">
                        </td>
                        <td class="weight-column">
                            <input type="text" class="form-control form-control-sm" formControlName="weight">
                        </td>
                        <td class="dehire-point-column">
                            <ng-select
                                formControlName="emptyDehirePoint"
                                [items]="availableMtLocations"
                                bindLabel="display"
                                bindValue="containerPortId"
                                [appendTo]="'body'"
                                dropdownPosition="bottom"
                                placeholder="Select dehire point"
                            ></ng-select>
                        </td>
                        
                        <td class="action-column">
                            <button type="button" class="btn btn-danger" [disabled]="containerGroups.length < 2" (click)="removeContainerGroup(containerGroupIndex)"> X </button>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        }
    </div>

    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-primary"
            (click)="onSubmit()"
            [disabled]="!canSubmitContainerUpdates || isSaving"
        >
            @if(isSaving){
            <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
            Updating...
            }@else{
            Update
            }
        </button>
        <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="activeModal.dismiss(false)"
        >Close</button>
    </div>
</form>
